// Common input styles
import { styled } from '@mui/material/styles';
import { Paper, SxProps, TextField } from '@mui/material';

export const inputStyles: SxProps = {
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderWidth: '1px',
    },
  },
};

// Custom-styled components
export const ConfigTextField = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderWidth: '1px',
    },
  },
  '& .MuiInputBase-input': {
    height: '10px',
    padding: '14px 14px',
  },
  minWidth: '200px',
  maxWidth: '100%',
  width: 'auto',
});

export const ConfigContainer = styled(Paper)({
  padding: '20px',
  borderRadius: '0',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  backgroundColor: 'transparent',
});
